var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowChevronUp = function SvgArrowChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9 16.35 12 9.3l-6.9 7.05-1.2-1.2L12 7.2l8.1 7.95-1.2 1.2z",
    fill: "#000"
  })));
};
export { SvgArrowChevronUp as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xOC45IDE2LjM1IDEyIDkuM2wtNi45IDcuMDUtMS4yLTEuMkwxMiA3LjJsOC4xIDcuOTUtMS4yIDEuMnoiIGZpbGw9IiMwMDAiLz4KPC9zdmc+Cg==";